// 为日历面板查价，然后填充到日历中


var
    // 在给定的日期基础上加上若干天，并格式化成 '2017-10-01' 的字符串返回
    addDays = require('../../util').addDays;


// 查价
function queryPrice(layero, month, option) {



    var params = {
        // ticketRangeId: layero.ticketRangeId,
        // ticketType: layero.ticketType,
        // priceType: layero.priceType,
        // paymentType: layero.paymentType,
        // itemId: layero.itemId,
        // formulaType: layero.formulaType,
        // startDateStr: layero.startDateStr,
        // endDateStr: layero.endDateStr
        hotelId: layero.hotelId,
        suppId: layero.suppId,
        roomType: layero.roomType,
        priceType: layero.priceType,
        startDateStr: layero.startDateStr,
        endDateStr: layero.endDateStr,
        currency: layero.currency
    };
    /**
        hotelId=75
        suppId=40224
        roomType=443
        priceType=3
        startDateStr=2024-07-24
        endDateStr=2024-08-20
        currency=RMB 
     */

    ///hotel/hotelCalendarPrice.do
    $.post('/hotel/hotelCalendarPrice.do', params, function (data) {
        // 将查询到的价格填充到日历中
        fillCalendarWithPrices(layero, data, option);
    });
}



// 将查询到的价格填充到日历中
function fillCalendarWithPrices(layero, res, option) {
    if (res.data && res.returnCode === 1) {

        var dayArr = $('.calendar-price-wrap').find('.cp-td-inner');

        $.each(res.data, function (date, o) {
            dayArr.each((i, e) => {
                var p = dayArr[i],
                    pDayStr = $(p).attr('data-day');
                
                if (pDayStr === date.replace(/-/g, '/')) {
                        
                    console.log("date", date);

                    
                    if(o.salePrice) {
                        let price = o.salePrice
                        var tmpStr =
                        `
                        <p class="calendar-p-price">￥ ${price} </p>
                        <span class="check-in-span hidden">入住</span>
                        <span class="check-out-span hidden">离店</span>
                        `;
                        $(p).append(tmpStr)
                        $(p).removeClass('disabled')
                    }
                      
                    // if (ele.formulaType == 3) {
                    //     let noprice = `<p class="calendar-p-price disabled">￥ ${ele.salePrice} </p> <p>已售罄</p>`;
                    //     $(p).append(noprice);
                    // } else {
                    //     $(p).append(tmpStr);
                    // }
                    // if (ele.salePrice && ele.formulaType != 3) {
                    //     $(p).removeClass('disabled')
                    // }
                }
            });
        });

        let hasCheckinDate = $('.calendar-price-wrap').find('.checkin').attr('data-day');
        if(hasCheckinDate) {
            let arrDom = $('.calendar-price-wrap').find('.cp-td-inner')
            setTmpGray(arrDom, hasCheckinDate);
        }

        if (option) {
            option
        }

        
        // $.each(res.data, function (i, o) {
        //     if (o.length) {
        //         $.each(o, function (i, ele) {
        //             var dayArr = $('.calendar-price-wrap').find('.cp-td-inner');

        //             dayArr.each((i, e) => {
        //                 var p = dayArr[i],
        //                     pDayStr = $(p).attr('data-day');
        //                 if (pDayStr === ele.validDate.replace(/-/g, '/')) {
        //                     var tmpStr =
        //                         `<p class="calendar-p-price">￥ ${ele.salePrice} </p>
        //                         <input type="hidden" id="paramsStore" data-carType = ${ele.carType}
        //                         data-validDate = ${ele.validDate.replace(/-/g, '/')}
        //                         data-isRealName = ${ele.isRealName}
        //                         data-ticketRangeId = ${ele.ticketRangeId}
        //                         data-stockId = ${ele.stockId}
        //                         data-formulaType = ${ele.formulaType}
        //                         data-paymentType = ${ele.paymentType}
        //                         data-priceType = ${ele.priceType}
        //                         data-ticketType = ${ele.ticketType}
        //                         data-suppName = ${ele.suppName}
        //                         data-suppId = ${ele.suppId}
        //                         data-itemId = ${ele.itemId}
        //                         data-infoId = ${ele.infoId}>
        //                         <span class="check-in-span hidden">入住</span>
        //                         <span class="check-out-span hidden">离店</span>`;
        //                     if (ele.formulaType == 3) {
        //                         let noprice = `<p class="calendar-p-price disabled">￥ ${ele.salePrice} </p> <p>已售罄</p>`;
        //                         $(p).append(noprice);
        //                     } else {
        //                         $(p).append(tmpStr);
        //                     }
        //                     if (ele.salePrice && ele.formulaType != 3) {
        //                         $(p).removeClass('disabled')
        //                     }
        //                 }
        //             });
        //         })
        //     }
        // });

        // let hasCheckinDate = $('.calendar-price-wrap').find('.checkin').attr('data-day');
        // if(hasCheckinDate) {
        //     let arrDom = $('.calendar-price-wrap').find('.cp-td-inner')
        //     setTmpGray(arrDom, hasCheckinDate);
        // }

        // if (option) {
        //     option
        // }
    } else if (res.returnCode === -400001) {
        alert('请先登录', { closeBtn: 0 }, function () {
            //跳转到首页
            location.href = '/user/bookHotel.do?';
        });
    } else {
        alert(res.errinfo);
    }

}

// 日期临时置灰 
// 1.先判断15天内是否有出现无价或者满房的日期
// 2.当选择了入住日期，则超过入住日期15天之后的日期全部置灰
function setTmpGray(dayArr, checkin) {
    if( dayArr && checkin ){
        
        var lastValidDay = new Date( addDays(checkin, 15, '/') + ' 23:59:59' );   // 第15天日期
        var checkinDate = new Date( checkin );      //当前选择的入住日期

        var hasNoPrice;

        for(var i = 0; i < dayArr.length; i++){
            var _date = new Date( $(dayArr[i]).attr('data-day') );     //  循环的这个月份日期

            if( hasNoPrice ) {
                $(dayArr[i]).addClass('disabled-checkout');
                // 价格也变成灰色
                $(dayArr[i]).find(".calendar-p-price").addClass('calendar-d-price');
                continue;
            }

            // 判断当前选择的日期15天内是否有包含disabled类
            if( _date > checkinDate  && _date < lastValidDay && $(dayArr[i]).hasClass('disabled')){
                $(dayArr[i]).removeClass('disabled');
                // 添加临时取消禁用disabled标识类
                $(dayArr[i]).addClass('temporary-cancel-disabled');
                hasNoPrice = new Date( $(dayArr[i]).attr('data-day') );
            }

            if( lastValidDay < _date ){   // 入住日期15天后的置灰
                $(dayArr[i]).addClass('disabled-checkout');
                // 价格也变成灰色
                $(dayArr[i]).find(".calendar-p-price").addClass('calendar-d-price');
            }

        }
    }
}


/**
 * layero : 价格日历所在的父元素
 * month  : 月份
 * option : 回调函数
 */
module.exports = function (layero, month, option) {
    queryPrice(layero, month, option);
};



// WEBPACK FOOTER //
// ./src/common/hotelCalendarPrice/modules/queryPriceForCalendar.js